import { COOKIE_KEYS, ParamCookieType, PARAMS_COOKIE_KEYS } from 'Consts/cookies.enum'

export type CookieOptions = {
  secure: boolean
  expires: number
}

export type LogicCookie = ParamCookieType | null

export const COOKIE_EXPIRATION_TIME = 24

export const COOKIE_OPTIONS = { expires: COOKIE_EXPIRATION_TIME, secure: true }

export const CookieHelper = () => {
  const setCookie = (name: string, val: string, options: CookieOptions) => {
    const date = new Date()
    const value = val
    //sets a 30 hour cookie
    date.setTime(date.getTime() + (options.expires ?? 24) * 60 * 60 * 1000)
    const secure = options.secure ? ';secure' : ''
    // Set it
    document.cookie = `${name}=${value};expires=${date.toUTCString()}; path=/${secure}'`
  }

  const getCookie = (name: string) => {
    const value = '; ' + document.cookie
    const parts = value.split('; ' + name + '=')

    if (parts.length == 2) {
      return parts?.pop()?.split(';').shift()
    }
  }

  const deleteCookie = (name: string) => {
    const expiresDate = new Date(0).toUTCString()
    const value = getCookie(name)

    // Delete also cookie from other sub domains
    if (value) {
      document.cookie = `${name}=${value};expires=${expiresDate};domain=cheq-platform.com;path=/`
    }
    document.cookie = `${name}=;expires=${expiresDate}; path=/`
  }

  let logicCookieData: LogicCookie = null
  let logicCookieTimeout: Date | null = null

  const getLogicCookieData = (paramName: string): string => {
    const timeout = !logicCookieTimeout || new Date().getTime() - logicCookieTimeout.getTime() > 500

    if (timeout || !logicCookieData) {
      logicCookieTimeout = new Date()
      const logicCookie = getCookie(COOKIE_KEYS.PARAMS) || null
      logicCookieData = logicCookie ? (JSON.parse(logicCookie) as LogicCookie) : null
    }

    return (logicCookieData && paramName in logicCookieData && logicCookieData[paramName]) || ''
  }

  const updateLogicCookieData = (paramName: string, value: string) => {
    getLogicCookieData(PARAMS_COOKIE_KEYS.SUBSCRIPTION_ID)
    if (logicCookieData) {
      logicCookieData[paramName] = value
      setCookie(COOKIE_KEYS.PARAMS, JSON.stringify(logicCookieData), { expires: 24, secure: true })
    }
  }

  return { getCookie, deleteCookie, setCookie, getLogicCookieData, updateLogicCookieData }
}
